module.exports = __webpack_public_path__ + "img/师资培训绿色.fe694739.jpg";